export const FETCH_COMPANIES_REQUESTED = "FETCH_COMPANIES_REQUESTED";

export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS";

export const FETCH_COLLEGES_REQUESTED = "FETCH_COLLEGES_REQUESTED";

export const FETCH_COLLEGES_SUCCESS = "FETCH_COLLEGES_SUCCESS";

export const FETCH_TAGS_REQUESTED = "FETCH_TAGS_REQUESTED";

export const FETCH_TAGS_SUCCESS = "FETCH_TAGS_SUCCESS";

export const UPDATE_MENTOR_EXPERIENCE_REQUESTED =
  "UPDATE_MENTOR_EXPERIENCE_REQUESTED";

export const UPDATE_MENTOR_EXPERIENCE_SUCCESS =
  "UPDATE_MENTOR_EXPERIENCE_SUCCESS";

export const FETCH_MENTOR_DETAILS_REQUESTED = "FETCH_MENTOR_DETAILS_REQUESTED";

export const FETCH_MENTOR_DETAILS_SUCCESS = "FETCH_MENTOR_DETAILS_SUCCESS";

export const FETCH_CURRENT_MENTOR_DETAILS_REQUESTED =
  "FETCH_CURRENT_MENTOR_DETAILS_REQUESTED";

export const FETCH_CURRENT_MENTOR_DETAILS_SUCCESS =
  "FETCH_CURRENT_MENTOR_DETAILS_SUCCESS";

export const UPDATE_LOADER_STATE = "UPDATE_LOADER_STATE";
